/**
 * Course summary showing participants and playlists (used in the collapsible course table).
 */

import React from 'react'
import {useStyles} from "./CourseSummary.css";
import Paper from "@mui/material/Paper";
import CourseParticipantCard from "../card/participant/CourseParticipantCard";
import CoursePlaylistCard from "../card/playlist/CoursePlaylistCard";
import useLoadCourse from "../utils/useLoadCourse";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import {FormattedMessage, useIntl} from "react-intl";

const CourseSummary = ({courseKey}) => {
    const classes = useStyles();

    // Internationalization for simple strings
    const intl = useIntl();

    const {
        course,
        loading
    } = useLoadCourse(courseKey)

    // Show loading indication while loading the course information
    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.courses.overview.table.expanded.loading', defaultMessage: 'Loading course info...'})}/>
    }

    return (
        <Paper className={classes.row}>

            {/* Course participants */}
            <div>
                <h3 className={classes.header}>
                    <FormattedMessage id={'app.courses.overview.table.expanded.participants.header'}
                                      defaultMessage={'Course Participants'}/>
                </h3>
                <div>
                    {course.participants.map((participant) => {
                        return <CourseParticipantCard key={participant.uid} user={participant}/>
                    })}
                </div>
            </div>

            {/* Course playlists */}
            <div>
                <h3 className={classes.header}>
                    <FormattedMessage id={'app.courses.overview.table.expanded.playlists.header'}
                                      defaultMessage={'Course Playlists'}/>
                </h3>
                <div>
                    {course.playlists.map((playlist, index) => {
                        return <CoursePlaylistCard key={playlist.key} showInfo={true} playlist={playlist}/>
                    })}
                </div>
            </div>
        </Paper>
    )
}

export default CourseSummary
